import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-952c9a8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "content-container"
}
const _hoisted_5 = { class: "top-content" }
const _hoisted_6 = { class: "flex-row-centered" }
const _hoisted_7 = { class: "center-buttons" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "table-container" }

import { ref, Ref, onMounted, computed, provide, inject } from "vue";
import { marketSelection } from "@/services/helpers/Helper";
import TablePersistentChecking, {
    ITableExpose,
} from "@/components/TablePersistentChecking.vue";
import PaymentItem from "@/Interfaces/Payments/ServiceInvoicePaymentItem";
import ServiceInvoicePaymentPopUp from "@/components/ServiceInvoicePaymentPopUp.vue";
import DatePeriod from "@/types/DatePeriod";
import { serviceInvoicePayments } from "@/services/network";
import PeriodSelector from "@/components/PeriodSelector.vue";
import MarketSelector from "@/components/MarketSelector.vue";
import useNotifier from "@/services/composables/Notifier";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceInvoicePayments',
  setup(__props) {

const cols: (keyof PaymentItem)[] = [
    "invoiceId",
    "balance",
    "amountTotal",
    "amountVAT",
    "issueDate",
    "periodMonth",
    "dueDate",
    "balanceDateUpdated",
];
const labels = [
    "Invoice Id",
    "Balance",
    "Amount Total",
    "Amount VAT",
    "Issue Date",
    "Period Month",
    "Due Date",
    "Balance Date Updated",
];

const page: Ref<number> = ref(1);
const rowCount: Ref<number> = ref(50);
provide("page", page);

// Table
const isLoading = ref(false);
const allPayments = ref<PaymentItem[]>([]);
const period = ref(new DatePeriod());

const displayedPayments = computed(() =>
    period.value.isValid()
        ? allPayments.value?.filter(
              (x) => x.periodMonth.valueOf() === period.value.valueOf()
          )
        : allPayments.value
);
const checkedRows = ref<PaymentItem[]>();
const hasCheckboxes = computed(() => period.value.isValid());
const selectedRows = ref<PaymentItem[]>();
const table = ref<ITableExpose<PaymentItem>>();

onMounted(async () => {
    marketSelection.value = "GB";
    getPayments();
});
async function getPayments() {
    //const errorType = 'Getting Recharge Invoices from API';
    try {
        isLoading.value = true;
        allPayments.value = (await serviceInvoicePayments.get()).data.map(
            (x) => new PaymentItem(x)
        );

        if (period.value.isValid()) {
            updateSelection();
        }
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting Service Invoices"})
    } finally {
        isLoading.value = false;
    }
}
const updateSelection = () => {
    checkedRows.value = undefined;
    selectedRows.value = undefined;
};
const proceedToPayment = () => {
    if (checked.value.length < 1) useNotifier().notify({ msg: "No item selected" });
    else {
        selectedRows.value = checked.value;
    }
};
const checked: Ref<PaymentItem[]> = computed(() => {
    return table.value?.GetChecked() ? table.value?.GetChecked() : [];
});
function refreshAfterConfirm() {
    period.value = new DatePeriod();
    getPayments();
    checkedRows.value = undefined;
}

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(MarketSelector),
            _createVNode(PeriodSelector, {
              modelValue: period.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
                updateSelection
              ],
              hasNullSelector: "",
              id: "periodSelector",
              showTitle: "",
              filter: (p) => allPayments.value?.some((x) => p.within(x.periodMonth))
            }, null, 8, ["modelValue", "filter"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                disabled: !hasCheckboxes.value,
                onClick: proceedToPayment,
                class: "incident-nav-button"
              }, " Confirm Payment ", 8, _hoisted_8)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(TablePersistentChecking, {
            ref_key: "table",
            ref: table,
            Rows: displayedPayments.value,
            Cols: cols,
            Labels: labels,
            HasCheckBox: hasCheckboxes.value,
            RowsPerPage: rowCount.value,
            "onUpdate:RowsPerPage": _cache[1] || (_cache[1] = ($event: any) => ((rowCount).value = $event))
          }, null, 8, ["Rows", "HasCheckBox", "RowsPerPage"])
        ]),
        _createVNode(ServiceInvoicePaymentPopUp, {
          modelValue: selectedRows.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedRows).value = $event)),
          onConfirm: refreshAfterConfirm
        }, null, 8, ["modelValue"])
      ]))
}
}

})